// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file agentplatform/v1/skill.proto (package infinigence.infini.agentplatform.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Param } from "./param_pb.js";
import { file_agentplatform_v1_param } from "./param_pb.js";
import { file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file agentplatform/v1/skill.proto.
 */
export const file_agentplatform_v1_skill: GenFile = /*@__PURE__*/
  fileDesc("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", [file_agentplatform_v1_param, file_google_protobuf_struct]);

/**
 * 定义技能组
 *
 * @generated from message infinigence.infini.agentplatform.v1.SkillGroup
 */
export type SkillGroup = Message<"infinigence.infini.agentplatform.v1.SkillGroup"> & {
  /**
   * 资源编号
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 技能组名称
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * 技能组描述
   *
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * 租户 ID
   *
   * @generated from field: string tenant_id = 5 [json_name = "tenant_id"];
   */
  tenantId: string;

  /**
   * 用户 ID
   *
   * @generated from field: string user_id = 6 [json_name = "user_id"];
   */
  userId: string;

  /**
   * 所属技能组类 ID
   *
   * @generated from field: string class_id = 7 [json_name = "class_id"];
   */
  classId: string;

  /**
   * 使用技能组类创建技能组时传入的参数列表
   *
   * @generated from field: map<string, string> class_params = 8 [json_name = "class_params"];
   */
  classParams: { [key: string]: string };

  /**
   * @generated from field: int64 created_at = 9 [json_name = "created_at"];
   */
  createdAt: bigint;

  /**
   * @generated from field: int64 updated_at = 10 [json_name = "updated_at"];
   */
  updatedAt: bigint;

  /**
   * @generated from field: int64 deleted_at = 11 [json_name = "deleted_at"];
   */
  deletedAt: bigint;

  /**
   * 技能组服务提供者
   *
   * @generated from field: string provider = 12;
   */
  provider: string;

  /**
   * 技能组包含的技能列表，key 是技能 ID，value 是技能版本
   *
   * @generated from field: map<string, int32> skills = 13;
   */
  skills: { [key: string]: number };
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.SkillGroup.
 * Use `create(SkillGroupSchema)` to create a new message.
 */
export const SkillGroupSchema: GenMessage<SkillGroup> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_skill, 0);

/**
 * 定义技能组类
 *
 * @generated from message infinigence.infini.agentplatform.v1.SkillGroupClass
 */
export type SkillGroupClass = Message<"infinigence.infini.agentplatform.v1.SkillGroupClass"> & {
  /**
   * 资源编号
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 技能组类名称
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * 技能组类描述
   *
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * 租户 ID
   *
   * @generated from field: string tenant_id = 5 [json_name = "tenant_id"];
   */
  tenantId: string;

  /**
   * 用户 ID
   *
   * @generated from field: string user_id = 6 [json_name = "user_id"];
   */
  userId: string;

  /**
   * 技能组 Template
   *
   * @generated from field: infinigence.infini.agentplatform.v1.SkillGroup template = 10;
   */
  template?: SkillGroup | undefined;

  /**
   * 技能组类参数
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.Param params = 11;
   */
  params: Param[];

  /**
   * @generated from field: int64 created_at = 12 [json_name = "created_at"];
   */
  createdAt: bigint;

  /**
   * @generated from field: int64 updated_at = 13 [json_name = "updated_at"];
   */
  updatedAt: bigint;

  /**
   * @generated from field: int64 deleted_at = 14 [json_name = "deleted_at"];
   */
  deletedAt: bigint;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.SkillGroupClass.
 * Use `create(SkillGroupClassSchema)` to create a new message.
 */
export const SkillGroupClassSchema: GenMessage<SkillGroupClass> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_skill, 1);

/**
 * @generated from message infinigence.infini.agentplatform.v1.Skill
 */
export type Skill = Message<"infinigence.infini.agentplatform.v1.Skill"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string author = 4;
   */
  author: string;

  /**
   * @generated from field: string user_id = 5 [json_name = "user_id"];
   */
  userId: string;

  /**
   * @generated from field: string tenant_id = 6 [json_name = "tenant_id"];
   */
  tenantId: string;

  /**
   * @generated from field: infinigence.infini.agentplatform.v1.SkillStatus status = 7;
   */
  status: SkillStatus;

  /**
   * @generated from field: string created_at = 8 [json_name = "created_at"];
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 9 [json_name = "updated_at"];
   */
  updatedAt: string;

  /**
   * @generated from field: repeated string tags = 10;
   */
  tags: string[];

  /**
   * @generated from field: repeated infinigence.infini.agentplatform.v1.SkillVersion versions = 11;
   */
  versions: SkillVersion[];

  /**
   * @generated from field: string file_path = 12 [json_name = "file_path"];
   */
  filePath: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.Skill.
 * Use `create(SkillSchema)` to create a new message.
 */
export const SkillSchema: GenMessage<Skill> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_skill, 2);

/**
 * @generated from message infinigence.infini.agentplatform.v1.SkillVersion
 */
export type SkillVersion = Message<"infinigence.infini.agentplatform.v1.SkillVersion"> & {
  /**
   * @generated from field: int32 version_code = 1 [json_name = "version_code"];
   */
  versionCode: number;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: string storage_path = 3 [json_name = "storage_path"];
   */
  storagePath: string;

  /**
   * @generated from field: bool is_stable = 4 [json_name = "is_stable"];
   */
  isStable: boolean;

  /**
   * @generated from field: bool is_latest = 5 [json_name = "is_latest"];
   */
  isLatest: boolean;

  /**
   * @generated from field: string status = 6;
   */
  status: string;

  /**
   * @generated from field: string branch = 7;
   */
  branch: string;

  /**
   * @generated from field: string created_by = 8 [json_name = "created_by"];
   */
  createdBy: string;

  /**
   * @generated from field: string content = 9;
   */
  content: string;

  /**
   * @generated from field: google.protobuf.Struct frontmatter = 10;
   */
  frontmatter?: JsonObject | undefined;

  /**
   * @generated from field: string entrypoint = 11;
   */
  entrypoint: string;

  /**
   * @generated from field: string content_hash = 12 [json_name = "content_hash"];
   */
  contentHash: string;

  /**
   * @generated from field: int32 file_count = 13 [json_name = "file_count"];
   */
  fileCount: number;

  /**
   * @generated from field: string created_at = 14 [json_name = "created_at"];
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 15 [json_name = "updated_at"];
   */
  updatedAt: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.SkillVersion.
 * Use `create(SkillVersionSchema)` to create a new message.
 */
export const SkillVersionSchema: GenMessage<SkillVersion> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_skill, 3);

/**
 * @generated from message infinigence.infini.agentplatform.v1.SkillFile
 */
export type SkillFile = Message<"infinigence.infini.agentplatform.v1.SkillFile"> & {
  /**
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * @generated from field: string mime_type = 2 [json_name = "mime_type"];
   */
  mimeType: string;

  /**
   * @generated from field: int32 size = 3;
   */
  size: number;

  /**
   * @generated from field: bool is_binary = 4 [json_name = "is_binary"];
   */
  isBinary: boolean;

  /**
   * @generated from field: string sha256 = 5;
   */
  sha256: string;

  /**
   * @generated from field: string updated_at = 6 [json_name = "updated_at"];
   */
  updatedAt: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.SkillFile.
 * Use `create(SkillFileSchema)` to create a new message.
 */
export const SkillFileSchema: GenMessage<SkillFile> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_skill, 4);

/**
 * @generated from message infinigence.infini.agentplatform.v1.SkillFileContent
 */
export type SkillFileContent = Message<"infinigence.infini.agentplatform.v1.SkillFileContent"> & {
  /**
   * @generated from field: infinigence.infini.agentplatform.v1.SkillFile file = 1;
   */
  file?: SkillFile | undefined;

  /**
   * @generated from field: string content = 2;
   */
  content: string;

  /**
   * @generated from field: string encoding = 3;
   */
  encoding: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.SkillFileContent.
 * Use `create(SkillFileContentSchema)` to create a new message.
 */
export const SkillFileContentSchema: GenMessage<SkillFileContent> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_skill, 5);

/**
 * @generated from message infinigence.infini.agentplatform.v1.SkillFileInput
 */
export type SkillFileInput = Message<"infinigence.infini.agentplatform.v1.SkillFileInput"> & {
  /**
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * @generated from field: string content = 2;
   */
  content: string;

  /**
   * @generated from field: string encoding = 3;
   */
  encoding: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.SkillFileInput.
 * Use `create(SkillFileInputSchema)` to create a new message.
 */
export const SkillFileInputSchema: GenMessage<SkillFileInput> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_skill, 6);

/**
 * @generated from message infinigence.infini.agentplatform.v1.CreateSkillPayload
 */
export type CreateSkillPayload = Message<"infinigence.infini.agentplatform.v1.CreateSkillPayload"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: string author = 3;
   */
  author: string;

  /**
   * @generated from field: string user_id = 4 [json_name = "user_id"];
   */
  userId: string;

  /**
   * @generated from field: string tenant_id = 5 [json_name = "tenant_id"];
   */
  tenantId: string;

  /**
   * @generated from field: int32 status = 6;
   */
  status: number;

  /**
   * @generated from field: repeated string tags = 7;
   */
  tags: string[];

  /**
   * @generated from field: string storage_path = 8 [json_name = "storage_path"];
   */
  storagePath: string;

  /**
   * @generated from field: string branch = 9;
   */
  branch: string;

  /**
   * @generated from field: string content = 10;
   */
  content: string;

  /**
   * @generated from field: repeated infinigence.infini.agentplatform.v1.SkillFileInput files = 11;
   */
  files: SkillFileInput[];
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.CreateSkillPayload.
 * Use `create(CreateSkillPayloadSchema)` to create a new message.
 */
export const CreateSkillPayloadSchema: GenMessage<CreateSkillPayload> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_skill, 7);

/**
 * @generated from message infinigence.infini.agentplatform.v1.UpdateSkillPayload
 */
export type UpdateSkillPayload = Message<"infinigence.infini.agentplatform.v1.UpdateSkillPayload"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: string author = 3;
   */
  author: string;

  /**
   * @generated from field: string user_id = 4 [json_name = "user_id"];
   */
  userId: string;

  /**
   * @generated from field: string tenant_id = 5 [json_name = "tenant_id"];
   */
  tenantId: string;

  /**
   * @generated from field: optional int32 status = 6;
   */
  status?: number | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.UpdateSkillPayload.
 * Use `create(UpdateSkillPayloadSchema)` to create a new message.
 */
export const UpdateSkillPayloadSchema: GenMessage<UpdateSkillPayload> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_skill, 8);

/**
 * @generated from message infinigence.infini.agentplatform.v1.CreateSkillVersionPayload
 */
export type CreateSkillVersionPayload = Message<"infinigence.infini.agentplatform.v1.CreateSkillVersionPayload"> & {
  /**
   * @generated from field: string description = 1;
   */
  description: string;

  /**
   * @generated from field: string storage_path = 2 [json_name = "storage_path"];
   */
  storagePath: string;

  /**
   * @generated from field: string branch = 3;
   */
  branch: string;

  /**
   * @generated from field: bool is_stable = 4 [json_name = "is_stable"];
   */
  isStable: boolean;

  /**
   * @generated from field: string created_by = 5 [json_name = "created_by"];
   */
  createdBy: string;

  /**
   * @generated from field: string content = 6;
   */
  content: string;

  /**
   * @generated from field: repeated infinigence.infini.agentplatform.v1.SkillFileInput files = 7;
   */
  files: SkillFileInput[];
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.CreateSkillVersionPayload.
 * Use `create(CreateSkillVersionPayloadSchema)` to create a new message.
 */
export const CreateSkillVersionPayloadSchema: GenMessage<CreateSkillVersionPayload> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_skill, 9);

/**
 * @generated from message infinigence.infini.agentplatform.v1.PromoteSkillVersionPayload
 */
export type PromoteSkillVersionPayload = Message<"infinigence.infini.agentplatform.v1.PromoteSkillVersionPayload"> & {
  /**
   * @generated from field: bool is_stable = 1 [json_name = "is_stable"];
   */
  isStable: boolean;

  /**
   * @generated from field: bool is_latest = 2 [json_name = "is_latest"];
   */
  isLatest: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.PromoteSkillVersionPayload.
 * Use `create(PromoteSkillVersionPayloadSchema)` to create a new message.
 */
export const PromoteSkillVersionPayloadSchema: GenMessage<PromoteSkillVersionPayload> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_skill, 10);

/**
 * @generated from message infinigence.infini.agentplatform.v1.UpdateSkillVersionContentPayload
 */
export type UpdateSkillVersionContentPayload = Message<"infinigence.infini.agentplatform.v1.UpdateSkillVersionContentPayload"> & {
  /**
   * @generated from field: string content = 1;
   */
  content: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.UpdateSkillVersionContentPayload.
 * Use `create(UpdateSkillVersionContentPayloadSchema)` to create a new message.
 */
export const UpdateSkillVersionContentPayloadSchema: GenMessage<UpdateSkillVersionContentPayload> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_skill, 11);

/**
 * @generated from message infinigence.infini.agentplatform.v1.PutSkillVersionFilePayload
 */
export type PutSkillVersionFilePayload = Message<"infinigence.infini.agentplatform.v1.PutSkillVersionFilePayload"> & {
  /**
   * @generated from field: string content = 1;
   */
  content: string;

  /**
   * @generated from field: string encoding = 2;
   */
  encoding: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.PutSkillVersionFilePayload.
 * Use `create(PutSkillVersionFilePayloadSchema)` to create a new message.
 */
export const PutSkillVersionFilePayloadSchema: GenMessage<PutSkillVersionFilePayload> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_skill, 12);

/**
 * @generated from message infinigence.infini.agentplatform.v1.ImportedSkillResult
 */
export type ImportedSkillResult = Message<"infinigence.infini.agentplatform.v1.ImportedSkillResult"> & {
  /**
   * 子目录相对路径(如 skill-a 或 skills/skill-a)
   *
   * @generated from field: string source_dir = 1 [json_name = "source_dir"];
   */
  sourceDir: string;

  /**
   * 成功才有
   *
   * @generated from field: string skill_id = 2 [json_name = "skill_id"];
   */
  skillId: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: int32 version_code = 4 [json_name = "version_code"];
   */
  versionCode: number;

  /**
   * @generated from field: bool success = 5;
   */
  success: boolean;

  /**
   * 失败原因
   *
   * @generated from field: string error = 6;
   */
  error: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.ImportedSkillResult.
 * Use `create(ImportedSkillResultSchema)` to create a new message.
 */
export const ImportedSkillResultSchema: GenMessage<ImportedSkillResult> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_skill, 13);

/**
 * @generated from enum infinigence.infini.agentplatform.v1.SkillStatus
 */
export enum SkillStatus {
  /**
   * @generated from enum value: UNAVAILABLE = 0;
   */
  UNAVAILABLE = 0,

  /**
   * @generated from enum value: AVAILABLE = 1;
   */
  AVAILABLE = 1,

  /**
   * @generated from enum value: UPLOADING = 2;
   */
  UPLOADING = 2,
}

/**
 * Describes the enum infinigence.infini.agentplatform.v1.SkillStatus.
 */
export const SkillStatusSchema: GenEnum<SkillStatus> = /*@__PURE__*/
  enumDesc(file_agentplatform_v1_skill, 0);

